module.exports = __webpack_public_path__ + "img/BGicon.8ed32bd7.png";